let _isFestiveMode = false;

export function setFestiveMode(isFestive: boolean) {
  _isFestiveMode = isFestive;
}

export function isFestiveMode(): boolean {
  return _isFestiveMode;
}
